/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { Children } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Mdx, Link } from '@ta-interaktiv/contentbricks'
import { MDXProvider } from '@mdx-js/react'
import { LogLogLine } from 'components/loglogline/component'

// TODO Set the correct article ID here
const ARTICLE_ID = '448154497109'

const COLORS = [
  '#E29E3F',
  '#95D0CF',
  '#75AD87',
  '#60B9B7',
  '#A3C8AF',
  '#9E5E9A',
  '#ECBE7F',
  '#DB5289',
  '#95D0CF',
  '#548984',
  '#BE94BC',
  '#8DB0AD',
  '#E78CB0',
  '#62647C',
  '#60B9B7'
]

const grp1 = [
  'CH',
  'AU',
  'BE',
  'DE',
  'CN',
  'DK',
  'AT',
  'MY',
  'ES',
  'FR',
  'IE',
  'FI',
  'IT',
  'JP',
  'NO'
]

const grp2 = ['ZA', 'PK', 'BD', 'CL', 'BR', 'MX', 'IN', 'SA']

const grp3 = ['PE', 'QA', 'RU', 'BY', 'IR', 'US', 'SE', 'TR', 'GB', 'CA']

const grp4 = ['BE', 'FR', 'DE', 'IE', 'IT', 'NL', 'PT', 'CH', 'TR', 'GB']

const HIGHLIGHTED = [
  'ZA',
  'CN',
  'CH',
  'DE',
  'CN',
  'RU',
  'BR',
  'AT',
  'ES',
  'BE',
  'SE',
  'IN',
  'PK',
  'US',
  'CA',
  'NL',
  'IL',
  'GB',
  'PT',
  'NO',
  'PE',
  'JP',
  'SA'
]
const ALIGN_BOTTOM = ['DE', 'NL', 'AU', 'ZA']

export function AppComponent() {
  return (
    <div className='index' id='app'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <MDXProvider
        components={{
          a: Link
        }}
      >
        <header className='ui vertical relaxed segment'>
          <div className='ui container'>
            <Mdx
              className='ui header'
              file={require('text/Af2EnQmq-xrb.mdx')}
            />
          </div>
        </header>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='metainfo'>
              <div className='author'>
                <nobr>Andreas Moor</nobr>, <nobr>Marc Brupbacher</nobr>
              </div>
              <div className='updated'>Aktualisiert am 17. Juni 2020</div>
            </div>
            <Mdx file={require('text/ZGtCoo0VCg71.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container chart'>
            {
              // Gruppe 1
            }
            <Mdx file={require('text/pUzDXHYLVrRb.mdx')} />
            <div className='chart-desc'>
              Anzahl täglicher Covid-19-Neuinfektionen verglichen mit der Anzahl
              aller Fälle; Länder mit über 5000 Fällen, logarithmische Skalen
            </div>
          </div>
          <LogLogLine
            showHint
            highlighted={grp1.reduce((acc, cur, i) => {
              acc[cur] = {
                color: cur === 'CH' ? '#f0636a' : COLORS[i],
                labelOptional: !HIGHLIGHTED.includes(cur),
                align: ALIGN_BOTTOM.includes(cur) ? 'bottom' : undefined
              }
              return acc
            }, {})}
          />
          <div className='ui text container chart'>
            <Mdx file={require('text/KromGQy5jgdE.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <Mdx file={require('text/EAzZRaV1BNV_.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container chart'>
            {
              // Gruppe 2
            }
            <Mdx file={require('text/AOUlR9OaViaf.mdx')} />
            <div className='chart-desc'>
              Anzahl täglicher Covid-19-Neuinfektionen verglichen mit der Anzahl
              aller Fälle; Länder mit über 5000 Fällen, logarithmische Skalen
            </div>
          </div>
          <LogLogLine
            highlighted={grp2.reduce((acc, cur, i) => {
              acc[cur] = {
                color: COLORS[i],
                labelOptional: !HIGHLIGHTED.includes(cur),
                align: ALIGN_BOTTOM.includes(cur) ? 'bottom' : undefined
              }
              return acc
            }, {})}
          />
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <Mdx file={require('text/HrUCOOGz98rw.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container chart'>
            {
              // Gruppe 3
            }
            <Mdx file={require('text/uS8DVR0AVls0.mdx')} />
            <div className='chart-desc'>
              Anzahl täglicher Covid-19-Neuinfektionen verglichen mit der Anzahl
              aller Fälle; Länder mit über 5000 Fällen, logarithmische Skalen
            </div>
          </div>
          <LogLogLine
            highlighted={grp3.reduce((acc, cur, i) => {
              acc[cur] = {
                color: COLORS[i],
                labelOptional: !HIGHLIGHTED.includes(cur),
                align: ALIGN_BOTTOM.includes(cur) ? 'bottom' : undefined
              }
              return acc
            }, {})}
          />
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <Mdx file={require('text/-pFK2kMx-Jji.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container chart'>
            {
              // Tote
            }
            <Mdx file={require('text/pZYB8xhabMwx.mdx')} />{' '}
            <div className='chart-desc'>
              Anzahl der täglichen durch Covid-19 verursachten Todesfälle
              verglichen mit der Anzahl aller durch Covid-19 verursachten
              Todesfälle; nach Land, logarithmische Skalen
            </div>
          </div>
          <LogLogLine
            highlighted={grp4.reduce((acc, cur, i) => {
              acc[cur] = {
                color: '#000',
                labelOptional: !['CH', 'BE', 'DE', 'FR', 'IT', 'GB'].includes(
                  cur
                ),
                align: ALIGN_BOTTOM.includes(cur) ? 'bottom' : undefined
              }
              return acc
            }, {})}
            hidden={['EC', 'ES']}
            y='dailyDeath'
            x='death'
            legendLabel='Todesfälle'
            legendScale={0.1}
          />
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <Mdx file={require('text/tbbblXgCj7EL.mdx')} />
          </div>
        </div>
      </MDXProvider>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Konzept und Umsetzung', 'Andreas Moor, Marc Brupbacher'],
          [
            'Inspiration',
            'Aatish Bhatia und Henry Reich von <a href="https://www.youtube.com/watch?v=54XLXg4fYsc" target="_blank">minutephysics</a>'
          ],
          [
            'Datenquelle',
            '<a href="https://coronavirus.jhu.edu/map.html" target="_blank">Johns Hopkins University</a>'
          ]
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie verständlich waren die Grafiken?'
        ]}
      />
    </div>
  )
}
